import { clsx } from 'clsx';

import styles from './StatusBadge.module.css';

export interface StatusBadgeProps {
  /** Text on the badge */
  label: string;
  /** true to render the card with high contrast colors; otherwise, false. The default is false. */
  highContrast?: boolean;
}

export const StatusBadge = ({ label, highContrast = false }: StatusBadgeProps) => {
  return (
    <div className={clsx(styles['statusbadge'], [highContrast && styles['statusbadge--high-contrast']])}>{label}</div>
  );
};
